export interface EmojiCategory {
  id: string;
  label: string;
  icon: string;
  emojis: string[];
}

export const EMOJI_CATEGORIES: EmojiCategory[] = [
  {
    id: 'fantasy',
    label: 'Fantasy & games',
    icon: '⚔️',
    emojis: [
      '⚔️', '🗡️', '🛡️', '🏹', '🔮', '🧙', '🧝', '🧚', '🧛', '🧟',
      '🐉', '🐲', '🦄', '🏰', '🏯', '⛰️', '🗺️', '🧭', '🎲', '📜', '🕯️', '🍺',
      '🍖', '💰', '👑', '💎', '🗝️', '🔥', '⚡', '❄️', '🌙', '⭐', '💀',
      '☠️', '🧪', '⚗️', '⛺', '🏴‍☠️', '🎭', '🎯', '🏆',
    ],
  },
  {
    id: 'smileys',
    label: 'Smileys',
    icon: '😀',
    emojis: [
      '😀', '😃', '😄', '😁', '😆', '😅', '🤣', '😂', '🙂', '🙃', '😉', '😊',
      '😇', '🥰', '😍', '🤩', '😘', '😋', '😛', '😜', '🤪', '😝', '🤗', '🤔',
      '🤨', '😐', '😑', '😶', '🙄', '😏', '😣', '😥', '😮', '😪', '😫', '🥱',
      '😴', '😌', '😎', '🤓', '🥳', '😕', '😟', '🙁', '😢', '😭', '😤', '😠',
      '😡', '🤬', '🤯', '😳', '🥵', '🥶', '😱', '😨', '😰', '🤢', '🤮', '🤧',
    ],
  },
  {
    id: 'gestures',
    label: 'Gestures',
    icon: '👍',
    emojis: [
      '👍', '👎', '👏', '🙌', '👐', '🤝', '🙏', '✌️', '🤞', '🤟', '🤘', '👌',
      '👈', '👉', '👆', '👇', '☝️', '✋', '🤚', '🖐️', '🖖', '👋', '💪',
      '🤙', '✍️', '🤳', '👀', '🧠',
    ],
  },
  {
    id: 'symbols',
    label: 'Hearts & symbols',
    icon: '❤️',
    emojis: [
      '❤️', '🧡', '💛', '💚', '💙', '💜', '🖤', '🤍', '🤎', '💔', '❣️', '💕',
      '💞', '💓', '💗', '💖', '💘', '💝', '✨', '🎉', '🎊', '✅', '❌', '⚠️',
      '❓', '❗', '💯', '🔔', '💬', '💡', '🚀', '🎁',
    ],
  },
  {
    id: 'nature',
    label: 'Animals & nature',
    icon: '🐺',
    emojis: [
      '🐶', '🐱', '🐭', '🐹', '🐰', '🦊', '🐻', '🐼', '🐨', '🐯', '🦁', '🐮',
      '🐷', '🐸', '🐵', '🐔', '🐧', '🐦', '🦅', '🦉', '🐺', '🐴', '🐝', '🦋',
      '🐢', '🐍', '🐙', '🦈', '🐬', '🌲', '🌳', '🌴', '🌵', '🌸', '🌹', '🍀',
      '🍄', '🌍', '🌈', '☀️', '🌧️', '🌊',
    ],
  },
  {
    id: 'food',
    label: 'Food & drink',
    icon: '🍕',
    emojis: [
      '🍎', '🍌', '🍇', '🍓', '🍕', '🍔', '🍟', '🌮', '🍗', '🍖', '🥩', '🍞',
      '🧀', '🍺', '🍻', '🍷', '🥂', '☕', '🍵', '🍰', '🎂', '🍪', '🍫', '🍿',
    ],
  },
];
